import { render, staticRenderFns } from "./Dinamicos.vue?vue&type=template&id=ba823186&scoped=true"
import script from "./Dinamicos.vue?vue&type=script&lang=js"
export * from "./Dinamicos.vue?vue&type=script&lang=js"
import style0 from "./Dinamicos.vue?vue&type=style&index=0&id=ba823186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba823186",
  null
  
)

export default component.exports